import { apiClient } from '../client';

export interface LogoUploadResult {
  url: string;
  variant: string;
}

export interface LogoUrls {
  lightLogoUrl: string | null;
  darkLogoUrl: string | null;
  backgroundImageUrl: string | null;
}

export const brandingService = {
  uploadLogo: async (file: File, variant: 'light' | 'dark'): Promise<LogoUploadResult> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('variant', variant);

    const response = await apiClient.post<LogoUploadResult>(
      '/api/app/branding/logo/upload',
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
    return response.data;
  },

  getLogoUrls: async (): Promise<LogoUrls> => {
    const response = await apiClient.get<LogoUrls>('/api/app/branding/logo/urls');
    return response.data;
  },

  deleteLogo: async (variant: 'light' | 'dark'): Promise<void> => {
    await apiClient.delete(`/api/app/branding/logo/${variant}`);
  },

  uploadBackground: async (file: File): Promise<LogoUploadResult> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post<LogoUploadResult>(
      '/api/app/branding/logo/background/upload',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },

  deleteBackground: async (): Promise<void> => {
    await apiClient.delete('/api/app/branding/logo/background');
  },
};
